/**
 * @generated SignedSource<<8302ec971b0cf37e40bca801469af6c9>>
 * @relayHash 6acb7af1e94f5345e9b36a8cd44c4bee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraLongRunningTaskStatus = "CANCELLED" | "CANCEL_REQUESTED" | "COMPLETE" | "DEAD" | "ENQUEUED" | "FAILED" | "RUNNING" | "%future added value";
export type mainIssueHierarchyQuery$variables = {
  cloudId: string;
};
export type mainIssueHierarchyQuery$data = {
  readonly jira: {
    readonly issueHierarchyConfig: {
      readonly data: ReadonlyArray<{
        readonly cmpIssueTypes: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly avatar: {
                readonly small: string | null | undefined;
              } | null | undefined;
              readonly description: string | null | undefined;
              readonly hierarchy: {
                readonly level: number | null | undefined;
              } | null | undefined;
              readonly id: string;
              readonly issueTypeId: string | null | undefined;
              readonly name: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly hierarchyLevel: {
          readonly level: number | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
      }> | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly code: string | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
    readonly issueHierarchyConfigUpdateTask: {
      readonly errors: ReadonlyArray<{
        readonly code: string | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly issueHierarchyConfig: ReadonlyArray<{
        readonly cmpIssueTypes: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly avatar: {
                readonly small: string | null | undefined;
              } | null | undefined;
              readonly description: string | null | undefined;
              readonly hierarchy: {
                readonly level: number | null | undefined;
              } | null | undefined;
              readonly id: string;
              readonly issueTypeId: string | null | undefined;
              readonly name: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly hierarchyLevel: {
          readonly level: number | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
      }> | null | undefined;
      readonly taskProgress: {
        readonly progress: AGG$Long;
        readonly status: JiraLongRunningTaskStatus;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"saveButton_adminPagesIssueHierarchyDirectory" | "saveDialog_adminPagesIssueHierarchyDirectory">;
    } | null | undefined;
    readonly issueHierarchyLimits: {
      readonly maxLevels: number;
      readonly nameLength: number;
    } | null | undefined;
    readonly lockedIssueTypeIds: ReadonlyArray<string> | null | undefined;
  } | null | undefined;
};
export type mainIssueHierarchyQuery = {
  response: mainIssueHierarchyQuery$data;
  variables: mainIssueHierarchyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "level"
},
v4 = [
  {
    "concreteType": "JiraIssueTypeHierarchyLevel",
    "kind": "LinkedField",
    "name": "hierarchyLevel",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/)
    ]
  },
  {
    "concreteType": "JiraIssueTypeConnection",
    "kind": "LinkedField",
    "name": "cmpIssueTypes",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraIssueTypeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "JiraIssueType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "issueTypeId"
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "concreteType": "JiraIssueTypeHierarchyLevel",
                "kind": "LinkedField",
                "name": "hierarchy",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              },
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "small"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v5 = {
  "concreteType": "JiraHierarchyConfigError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "code"
    },
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v6 = {
  "args": (v1/*: any*/),
  "concreteType": "JiraIssueHierarchyConfigurationQuery",
  "kind": "LinkedField",
  "name": "issueHierarchyConfig",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueHierarchyConfigData",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "ScalarField",
      "name": "success"
    },
    (v5/*: any*/)
  ]
},
v7 = {
  "args": (v1/*: any*/),
  "concreteType": "JiraIssueHierarchyLimits",
  "kind": "LinkedField",
  "name": "issueHierarchyLimits",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "maxLevels"
    },
    {
      "kind": "ScalarField",
      "name": "nameLength"
    }
  ]
},
v8 = {
  "args": (v1/*: any*/),
  "kind": "ScalarField",
  "name": "lockedIssueTypeIds"
},
v9 = {
  "concreteType": "JiraIssueHierarchyConfigData",
  "kind": "LinkedField",
  "name": "issueHierarchyConfig",
  "plural": true,
  "selections": (v4/*: any*/)
},
v10 = {
  "concreteType": "JiraLongRunningTaskProgress",
  "kind": "LinkedField",
  "name": "taskProgress",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "progress"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainIssueHierarchyQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraHierarchyConfigTask",
            "kind": "LinkedField",
            "name": "issueHierarchyConfigUpdateTask",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "saveButton_adminPagesIssueHierarchyDirectory"
              },
              {
                "kind": "FragmentSpread",
                "name": "saveDialog_adminPagesIssueHierarchyDirectory"
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainIssueHierarchyQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraHierarchyConfigTask",
            "kind": "LinkedField",
            "name": "issueHierarchyConfigUpdateTask",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b",
    "metadata": {},
    "name": "mainIssueHierarchyQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e780e64aedcd2278004df68a042f1343";

export default node;
